import { render, staticRenderFns } from "./ForgotPasswordSent.vue?vue&type=template&id=02906f84&scoped=true"
import script from "./ForgotPasswordSent.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSent.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordSent.vue?vue&type=style&index=0&id=02906f84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02906f84",
  null
  
)

export default component.exports